module.exports = __webpack_public_path__ + "static/media/storefront.db158da7.jpg";